var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditMessage = function SvgEditMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#edit-message_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.452 4.621-1.278 1.35 2.94 3.105 1.277-1.35c.193-.203.346-.445.45-.712a2.3 2.3 0 0 0 0-1.68 2.2 2.2 0 0 0-.45-.713A2.07 2.07 0 0 0 17.921 4c-.547 0-1.073.222-1.47.621M16.939 10.317l-2.94-3.105-3.93 4.146a.9.9 0 0 0-.227.449l-.437 2.329a.9.9 0 0 0 .02.427c.039.138.11.264.207.367a.8.8 0 0 0 .347.22.8.8 0 0 0 .404.02l2.206-.466a.8.8 0 0 0 .424-.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.07 11.358a.9.9 0 0 0-.228.449l-.437 2.329a.9.9 0 0 0 .02.427c.039.138.11.264.207.367a.8.8 0 0 0 .347.22.8.8 0 0 0 .404.02l2.206-.466a.8.8 0 0 0 .424-.24l3.926-4.147-2.94-3.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.806 15.49a1.64 1.64 0 0 1-.85.48l-2.94.62a1.6 1.6 0 0 1-.808-.04 1.65 1.65 0 0 1-.694-.44 1.8 1.8 0 0 1-.415-.733 1.85 1.85 0 0 1-.04-.853l.588-3.105c.065-.34.223-.652.455-.898l4.091-4.32a1 1 0 0 1-.035-.253H5.802c-.478 0-.936.201-1.274.558A1.96 1.96 0 0 0 4 7.851v10.246c0 .505.19.988.528 1.345S5.324 20 5.802 20h9.7c.478 0 .936-.201 1.274-.558a1.96 1.96 0 0 0 .528-1.345v-6.302z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edit-message_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h16v16H4z"
  })))));
};
export default SvgEditMessage;